import React, { useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
// import { useMediaQuery } from 'react-responsive';
import { Helmet } from 'react-helmet-async';
import Header from './Header';
// import 'pwa-mmt-ui-header/ssr/header.css';
import * as metadata from './metadata';
import { delayedScheduler } from './utils/scheduler';

import './styles/base.css';
import './styles/layout.css';
import './styles/busEnhancement.css';
import './styles/cabSeoSprite.css';
import './styles/templateCommon.css';
import loadable from '@loadable/component';
import { config } from './constants/adsConfig';
import { setConfig } from './AdTechConfig';
if (typeof fetch === 'undefined') {
  // Polyfill fetch only if missing (Node <18); Node 20 already provides it.
  require('isomorphic-fetch');
}
const CityTemplate = loadable(
  () => import('./pages/CityTemplate/CityTemplate'),
);
const CityOperatorTemplate = loadable(
  () => import('./pages/CityOperatorTemplate/CityOperatorTemplate'),
);
const CityCategoryTemplate = loadable(
  () => import('./pages/CityCategoryTemplate/CityCategoryTemplate'),
);
const RouteTemplate = loadable(
  () => import('./pages/RouteTemplate/RouteTemplate'),
);
const StaticListIndexSingle = loadable(
  () => import('./pages/BusCityIndex/StaticListIndexSingle'),
);
const StaticListIndexRoute = loadable(
  () => import('./pages/BusRouteIndex/StaticListIndexRoute'),
);
const StaticListIndexOperator = loadable(
  () => import('./pages/BusOperatorIndex/StaticListIndexOperator'),
);
const StaticListIndexRouteCategory = loadable(
  () => import('./pages/BusRouteCategoryIndex/StaticListIndexRouteCategory'),
);
const OperatorTemplate = loadable(
  () => import('./pages/OperatorTemplate/OperatorTempate'),
);
const RouteCategoryTemplate = loadable(
  () => import('./pages/RouteCategoryTemplate/RouteCategoryTemplate'),
);
const RouteOperatorTemplate = loadable(
  () => import('./pages/RouteOperatorTemplate/RouteOperatorTemplate'),
);

setConfig(config);

// Adding delayScheduler to pwatracker scheduler : window.schedulerDelay
if (typeof window !== 'undefined') {
  window.schedulerDelay = delayedScheduler;
}

const NoMatch = ({ location }) => (
  <div>
    <h3>
      No match for <code>{location.pathname}</code>
    </h3>
  </div>
);

const App = ({ data }) => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line no-unused-expressions
      import('lazysizes');
    }
  }, []);

  const templateType = data?.templateData?.templateName;

  const noIndexIdList = [
    1628, 5868, 5869, 5870, 5871, 5872, 5873, 482, 3402, 530, 886, 6501
  ];
  //Gobus : 6501
  // MSRTC: 1628, 5868, 5869, 5870, 5871, 5872, 5873
  // Shreenathji Darshan Travels: 482
  // Shreenath Yadav Travels: 3402
  // Jai Shrinath ji ki Travels: 530
  // Jai Shrinath Ji Ki: 886

  const isNoIndexPage =
    (templateType === 'operator' && noIndexIdList.includes(data?.id)) ||
    (templateType === 'route_operator' &&
      noIndexIdList.includes(data?.operatorId)) ||
    (templateType === 'city_operator' &&
      noIndexIdList.includes(data?.operatorId)) ||
    false;

  return (
    <>
      <div className={`desktopShow`}>
        <Header selectedTabName="Buses" />
      </div>
      <Helmet
        title={data.templateData.metaTitle}
        meta={metadata.meta}
        script={metadata.script}
        noscript={metadata.noscript}
      />
      {isNoIndexPage && (
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
      )}
      <div>
        <Switch>
          <Route
            exact
            path="/cityOperator/:cityOperatorId"
            render={(props) => <CityOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-city-operator-buses.html"
            render={(props) => <CityOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/cityCategory/:cityCategoryId"
            render={(props) => <CityCategoryTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-bus-services.html"
            render={(props) => <CityCategoryTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/routeOperator/:routeOperatorId"
            render={(props) => <RouteOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-from-*-to-*-online-bus-tickets.html"
            render={(props) => <RouteOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-online-buses.html"
            render={(props) => <RouteOperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/operator/:operatorId"
            render={(props) => <OperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-bus-booking.html"
            render={(props) => <OperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-bus-online-booking.html"
            render={(props) => <OperatorTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/city/:cityCode"
            render={(props) => <CityTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-online-booking.html"
            render={(props) => <CityTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/route/:fromCityCode/:toCityCode"
            render={(props) => <RouteTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-*-bus-ticket-booking.html"
            render={(props) => <RouteTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/routeCategory/:routeCategoryId"
            render={(props) => <RouteCategoryTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/*-online-ticket-booking.html"
            render={(props) => <RouteCategoryTemplate data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/city-index_:letter_:page.html"
            render={(props) => <StaticListIndexSingle data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/city-index_*_*.html"
            render={(props) => <StaticListIndexSingle data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/city-index.html"
            render={(props) => <StaticListIndexSingle data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/city-index.html"
            render={(props) => <StaticListIndexSingle data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/city-city-index_:letter_:page.html"
            render={(props) => <StaticListIndexRoute data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/city-city-index_*_*.html"
            render={(props) => <StaticListIndexRoute data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/city-city-index.html"
            render={(props) => <StaticListIndexRoute data={data} {...props} />}
          />
          <Route
            exact
            path="/bus-tickets/city-city-index.html"
            render={(props) => <StaticListIndexRoute data={data} {...props} />}
          />
          <Route
            exact
            path="/staticPage/bus-operator-index.html"
            render={(props) => (
              <StaticListIndexOperator data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/bus-tickets/bus-operator-index.html"
            render={(props) => (
              <StaticListIndexOperator data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/staticPage/bus-operator-index_:letter_:page.html"
            render={(props) => (
              <StaticListIndexOperator data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/bus-tickets/bus-operator-index_:letter_:page.html"
            render={(props) => (
              <StaticListIndexOperator data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/staticPage/city-city-bus-type-index.html"
            render={(props) => (
              <StaticListIndexRouteCategory data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/bus-tickets/city-city-bus-type-index.html"
            render={(props) => (
              <StaticListIndexRouteCategory data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/staticPage/city-city-bus-type-index_:letter_:page.html"
            render={(props) => (
              <StaticListIndexRouteCategory data={data} {...props} />
            )}
          />
          <Route
            exact
            path="/bus-tickets/city-city-bus-type-index_:letter_:page.html"
            render={(props) => (
              <StaticListIndexRouteCategory data={data} {...props} />
            )}
          />

          <Route component={NoMatch} />
        </Switch>
      </div>
    </>
  );
};

export default App;
